export default __webpack_public_path__ + "static/media/pencil-soft-summer.f7b504fe.png";